package com.devi3east.bashbuddy.prizeList.requests

import com.devi3east.bashbuddy.prizeList.domain.models.PrizeType
import com.devi3east.bashbuddy.account.profile.domain.models.Profile
import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class UpdatePrizeRequest(
    val prizeType: PrizeType,
    val title: String? = null,
    val timeSlot: Instant? = null,
    val serialNumber: String? = null,
    val winningNumber: String? = null,
    val winnerProfile: Profile? = null
)